// Reference: https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override

export const stylesDark = {
	h1: { color: "var(--white)" },
	h2: { color: "var(--white)" },
	h3: { color: "var(--white)" },
	h4: { color: "var(--white)" },
	h5: { color: "var(--white)" },
	body1: { color: "var(--white)" },
	p: { color: "var(--white)" },

	/*=====
		ReactTable (material-react-table)
	=====*/
	// table background color wrong color
	".reactTable .MuiPaper-root.MuiPaper-elevation2,.reactTable .MuiBox-root, .MuiTableCell-root.MuiTableCell-body, .MuiTableCell-root.MuiTableCell-head": {
		background: "var(--darkmode-white)",
	},
	".reactTable .MuiPaper-root.MuiPaper-elevation1": {
		backgroundImage: "none",
	},
	// table row divider wrong color
	".MuiTableCell-root.MuiTableCell-body": {
		borderBottomColor: "var(--darkmode-lightgray)",
	},

	/*=====
		Forms
	=====*/
	// some form lables not white
	".MuiFormControlLabel-label": {
		color: "var(--white)",
	},
};
